import React, {useState} from 'react'
import swiperBg from '@assets/img/swiperBg.png'
import TodayDynamics from './todayDynamics'
import PlayTimeData from './playTimeData'
import ClientManagement from './clientManagement'
import NodeOnlineRate from './nodeOnlineRate'
import NodeMonitoring from './nodeMonitoring'
import LastPhotos from './lastPhotos'
import './index.less'

export default function CockpitClientManagement() {
  return (
    <div className="client-management">
      <img src={swiperBg} className='client-index-img'/>
      <div className='client-index-item'>
        <div className='client-index-top'>
          <div className='client-index-left'>
            <TodayDynamics/>
            <PlayTimeData/>
          </div>
          <div className='client-index-center'>
            <ClientManagement/>
          </div>
          <div className='client-index-right'>
            <NodeOnlineRate/>
            <NodeMonitoring/>
          </div>
        </div>
        <div className='client-index-bottom'>
          <LastPhotos />
        </div>
      </div>
    </div>
  )
}
